import { UcaNavigation } from './UcaNavigation';

export default UcaNavigation;
